import { Injectable } from '@angular/core';
import { AuthentificationService } from '@app/authentification/authentification.service';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { Observable, map, switchMap, take } from 'rxjs';
import { Dao } from '../dao';
import { DataLoaderAuthentified } from '../data-loader-authentified';

@Injectable({
  providedIn: 'root',
})
export class AttributionDao extends Dao {
  private attribution: DataLoaderAuthentified<any> =
    new DataLoaderAuthentified<any>(this.getAuthentified(), user =>
      this.httpApi.get(
        `/organization/${user.organizationId}/accounts/${user.accountId}/attribution`,
      ),
    );

  constructor(
    httpApi: HttpApiService,
    authentificationService: AuthentificationService,
  ) {
    super(httpApi, authentificationService);
  }

  /* Attribution */
  getAttribution(): Observable<any> {
    return this.attribution.get();
  }

  /**
   * Lecture one-shot de l'attribution : émet une fois puis complète.
   *
   * getAttribution() renvoie un flux vif qui ne complète jamais — inutilisable
   * dans un forkJoin ou un guard, où il gèlerait l'un comme l'autre.
   */
  getAttributionOnce(): Observable<any> {
    return this.attribution.current$();
  }

  getConsultant(): Observable<any> {
    return this.getAttribution().pipe(
      map(attribution => attribution?.mainConsultant),
    );
  }

  getConsultantForActivity(activity: string | null): Observable<any> {
    if (!activity) return this.getConsultant();

    return this.getAuthentified().pipe(
      take(1),
      switchMap(user =>
        this.httpApi.get(
          `/organization/${user.organizationId}/accounts/${user.accountId}/attribution`,
          { activity },
        ),
      ),
      map((attribution: any) => attribution?.mainConsultant),
    );
  }

  getOrganization(): Observable<any> {
    return this.getAttribution().pipe(
      map(attribution => attribution?.organization),
    );
  }

  /* state */
  onUserChange(event: any) {
    this?.reset();
  }

  reset() {
    if (this.attribution) this.attribution?.reset();
  }
}
